export default __webpack_public_path__ + "static/media/g.d8d7330e.mp3";